module.exports = __webpack_public_path__ + "static/media/mini-set.2ebfa47b.png";